import styled from 'styled-components';

export const Subtext = styled.p`
  color: var(--color-gray-medium);
`;
